import React from "react";
import { Accordion, Button, Illustration, Text } from "@mbank-design/design-system/components";
import { CarHighwayMass } from "@mbank-design/design-system/illustrations";
import { useMobileOnlyMedia } from "@mbank-design/design-system/components/Media/useMobileOnlyMedia";

import "./index.scss";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useState } from "react";
export const CarAcquisitionSection = () => {

  const [isSelected ,setIsSelected] = useState(null)

  const selectHandler = (number) => {
    if(number === isSelected){
      setIsSelected(null)
      return
    }
    setIsSelected(number)
  }

  const isMobile = useMobileOnlyMedia()
  return (
    <div className="car-acquisition-section">
      <div className="car-acquisition-section__container">
        <div className="car-acquisition-section__header">
          <Text as="h2" styledAs={"h1"}> jak to działa?</Text>
          <Text as={"body"}>tylko 3 kroki dzielą Cię od tego, by jeździć nowym autem</Text>
        </div>
        <div className="car-acquisition-section__content">
          <Illustration illustrationComponent={CarHighwayMass} size={isMobile ? 312 : 512} />
          <div className="car-acquisition-section__typo">
            <Accordion isOnlyOneSection layout="large" >
              <Accordion.Item >
                <div className="car-acquisition-section__typo__item">
                  <Accordion.Header level="3" onClick={() => selectHandler(1)}><span className={`car-acquisition-section__typo__item-number ${isSelected === 1 && "selected"}`}>1</span>wybierz samochód</Accordion.Header>
                  <Accordion.Content>
                    <Text as={"body"} marginLeft={64}>
                      Wybierz samochód z dostępnych na naszej stronie lub zapytaj nas o finansowanie samochodu spoza strony.
                    </Text>
                  </Accordion.Content>
                </div>
              </Accordion.Item>
              <Accordion.Item>
                <div className="car-acquisition-section__typo__item">
                  <Accordion.Header level="3" onClick={() => selectHandler(2)}><span className={`car-acquisition-section__typo__item-number ${isSelected === 2 && "selected"}`}>2</span>podpisz umowę finansowania</Accordion.Header>
                  <Accordion.Content>
                    <Text as={"body"} marginLeft={64}>
                      Nasz doradca przygotuje dla Ciebie ofertę finansowania zgodną z Twoimi oczekiwaniami. Dostarcz
                      dokumenty niezbędne do decyzji i podpisz z nami umowę finansowania samochodu.
                    </Text>
                  </Accordion.Content>
                </div>
              </Accordion.Item>
              <Accordion.Item>
                <div className="car-acquisition-section__typo__item">
                  <Accordion.Header level="3" onClick={() => selectHandler(3)}><span className={`car-acquisition-section__typo__item-number ${isSelected === 3 && "selected"}`}>3</span>odbierz samochód</Accordion.Header>
                  <Accordion.Content>
                    <Text as={"body"} marginLeft={64}>
                      Odbierz swój nowy samochód i ciesz się jazdą!
                    </Text>
                  </Accordion.Content>
                </div>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
        <Link to="/nowe-samochody"><Button>znajdź samochód</Button></Link>
      </div>
    </div>
  );
};
